"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationNamedTemplateBuilder = void 0;
var abstract_builder_1 = require("./abstract-builder");
var notification_named_template_1 = require("../structs/notification-named-template");
var NotificationNamedTemplateBuilder = (function (_super) {
    __extends(NotificationNamedTemplateBuilder, _super);
    function NotificationNamedTemplateBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = notification_named_template_1.NotificationNamedTemplate;
        return _this;
    }
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "channels", {
        get: function () {
            return this.data.channels;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setChannels = function (channels) {
        this.data.channels = Array.from(channels);
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "templateContent", {
        get: function () {
            return this.data.templateContent;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setTemplateContent = function (content) {
        this.data.templateContent = content;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "createdAt", {
        get: function () {
            return this.data.createdAt;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setCreatedAt = function (date) {
        this.data.createdAt = date;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "createdBy", {
        get: function () {
            return this.data.createdBy;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setCreatedBy = function (id) {
        this.data.createdBy = id;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "description", {
        get: function () {
            return this.data.description;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setDescription = function (description) {
        this.data.description = description;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "destroyedAt", {
        get: function () {
            return this.data.destroyedAt;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setDestroyedAt = function (date) {
        this.data.destroyedAt = date;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "destroyedBy", {
        get: function () {
            return this.data.destroyedBy;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setDestroyedBy = function (id) {
        this.data.destroyedBy = id;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "domainId", {
        get: function () {
            return this.data.domainId;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setDomainId = function (id) {
        this.data.domainId = id;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "id", {
        get: function () {
            return this.data.id;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setId = function (id) {
        this.data.id = id;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "keywords", {
        get: function () {
            return this.data.keywords;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setKeywords = function (keywords) {
        this.data.keywords = !keywords ? undefined : Array.from(keywords);
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "name", {
        get: function () {
            return this.data.name;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setName = function (name) {
        this.data.name = name;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "sourceTemplateId", {
        get: function () {
            return this.data.sourceTemplateId;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setSourceTemplateId = function (id) {
        this.data.sourceTemplateId = id;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "templateExcludedSegmentIds", {
        get: function () {
            return this.data.templateExcludedSegmentIds;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setTemplateExcludedSegmentIds = function (ids) {
        this.data.templateExcludedSegmentIds = !ids ? undefined : Array.from(ids);
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "templateSegmentIds", {
        get: function () {
            return this.data.templateSegmentIds;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setTemplateSegmentIds = function (ids) {
        this.data.templateSegmentIds = !ids ? undefined : Array.from(ids);
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "templateTtlSpec", {
        get: function () {
            return this.data.templateTtlSpec;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setTemplateTtlSpec = function (spec) {
        this.data.templateTtlSpec = spec;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "updatedAt", {
        get: function () {
            return this.data.updatedAt;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setUpdatedAt = function (date) {
        this.data.updatedAt = date;
        return this;
    };
    Object.defineProperty(NotificationNamedTemplateBuilder.prototype, "updatedBy", {
        get: function () {
            return this.data.updatedBy;
        },
        enumerable: false,
        configurable: true
    });
    NotificationNamedTemplateBuilder.prototype.setUpdatedBy = function (id) {
        this.data.updatedBy = id;
        return this;
    };
    return NotificationNamedTemplateBuilder;
}(abstract_builder_1.AbstractBuilder));
exports.NotificationNamedTemplateBuilder = NotificationNamedTemplateBuilder;
//# sourceMappingURL=notification-named-template-builder.js.map